export function showError(meta = {}) {
    const { submitError, error, touched, dirtySinceLastSubmit } = meta;
    return ((submitError && !dirtySinceLastSubmit) || error) && touched;
}

export const trimWhitespaces = value => (value ? value.trim() : value);
